import { render, staticRenderFns } from "./commonField.vue?vue&type=template&id=0a9bef22&scoped=true"
import script from "./commonField.vue?vue&type=script&lang=js"
export * from "./commonField.vue?vue&type=script&lang=js"
import style0 from "./commonField.vue?vue&type=style&index=0&id=0a9bef22&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9bef22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9bef22')) {
      api.createRecord('0a9bef22', component.options)
    } else {
      api.reload('0a9bef22', component.options)
    }
    module.hot.accept("./commonField.vue?vue&type=template&id=0a9bef22&scoped=true", function () {
      api.rerender('0a9bef22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonField.vue"
export default component.exports